const state = {
  application: {
    clientId: null,
    fullName: null,
    description: null
  }
}

const getters = {
  getApplication: (state) => state.application
}

const mutations = {
  setApplication(state, application) {
    state.application = application
  }
}

const actions = {
  setApplication(context, application) {
    context.commit('setApplication', application)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
